import { render, staticRenderFns } from "./HabitatGraph.vue?vue&type=template&id=4bb62e66&"
import script from "./HabitatGraph.vue?vue&type=script&lang=js&"
export * from "./HabitatGraph.vue?vue&type=script&lang=js&"
import style0 from "./HabitatGraph.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports